<template>
  <div v-if="clientSites != null && selectedSite != null" class="client-sites">
    <vue-select id="client-sites" key="client-sites" :attributes="clientSitesAttributes" @changed="changed"></vue-select>
  </div>    
</template>

<script>
    import notificator from '../../mixins/notificator';

    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'

    import VueSelect from '@/components/Fields/Select.vue';

    export default {
        components: {VueSelect},

        mixins: [notificator],

        data() {
            return {
                clientSitesAttributes: {
                    classes: {value: 'form-control multiselect-blu'},
                    idField: {value: 'siteId'},
                    labelField: {value: 'siteName'},
                    options: {value: this.clientSites},
                    required: {value: true},
                    value: {value: null}
                },
            }
        },

        created() {
            if(this.clientSites == undefined || this.clientSites == null) {
                this.getClientSites();
            } else {
                this.clientSitesAttributes['options']['value'] = this.clientSites;
            }
            
            if(this.clientSites != undefined && this.clientSites != null && this.selectedSite != null){
                this.clientSitesAttributes['value']['value'] = this.selectedSite;
            }
        },

        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters([
                'clientSites',
                'selectedSite',
                'clientSiteDefaultSiteId'
            ])
        },

        watch: {
            clientSites() {
                if(this.clientSites[0] != undefined) {
                    this.clientSitesAttributes['options']['value'] = this.clientSites;
                    this.clientSitesAttributes['value']['value'] = this.clientSites[0]['siteId'];
                    this.$store.dispatch('changeClientSite', this.clientSites[0], true)
                }                
            }
        },

        // selectedSite() {
        //     this.clientSitesAttributes['value']['value'] = this.selectedSite;
        // },

        methods: {
            ...mapActions([
                'getClientSites',
                'changeClientSite'
            ]),

            getClientSites() {
            
            this.$store
                .dispatch('getClientSites')
                .catch(error => {
                    this.overlay(false);
                    this.notify(this.$options.filters.notification({endpoint: 'GetClientSites', code: error}));            
                })
                .then(({data}) => {
                    this.notify(this.$options.filters.notification({endpoint: 'GetClientSites', code: 200}));
                    
                    if(data.clientSites != undefined) {
                        this.clientSitesAttributes['options']['value'] = data.clientSites;

                        var found = false;
                        if(this.clientSiteDefaultSiteId != undefined && this.clientSiteDefaultSiteId != null) {
                            //Ciclo la lista dei siti e trovo il sito corrispondente              
                            for(var i = 0; i < data.clientSites.length; i++) {
                                if(data.clientSites[i]['siteId'] == this.clientSiteDefaultSiteId) {
                                    this.clientSitesAttributes['value']['value'] = data.clientSites[i]['siteId'];
                                    this.$store.dispatch('changeClientSite', data.clientSites[i])
                                    found = true;
                                    break;
                                }
                            }                            
                        } 
                        
                        if(!found && data.clientSites[0] != undefined) {
                            this.clientSitesAttributes['value']['value'] = data.clientSites[0]['siteId'];
                            this.$store.dispatch('changeClientSite', data.clientSites[0])
                        }
                            
                    } else
                        this.clientSitesAttributes['options']['value'] = [];
                });          
            },

            changed(changed) {
                if(this.selectedSite != changed.value) 
                    this.changeClientSite(changed.object);                
            }
        }
    }
</script>
